export default "__VITE_ASSET__BbdQZS_d__"